import { render, staticRenderFns } from "./paymob-valu-checkout.vue?vue&type=template&id=bbab6504"
import script from "./paymob-valu-checkout.vue?vue&type=script&lang=js"
export * from "./paymob-valu-checkout.vue?vue&type=script&lang=js"
import style0 from "./paymob-valu-checkout.vue?vue&type=style&index=0&id=bbab6504&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports